import React from "react";
import "./Footer.css";
import { Link, useLocation } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { faPaperPlane, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram, faXTwitter } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  const location = useLocation();

  return (
    <>
      <section className="Footer">
        <div className="container">
          <div className="web_logo_holder">
            <img
              className="logo_img"
              src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
              alt="Rent Easy logo"
            />
          </div>

          <div className="footer_main_link_holder">
            <Nav.Link as={Link} to="/" className={location.pathname === "/" ? "active" : ""}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/about-us" className={location.pathname === "/about-us" ? "active" : ""}>
              About Us
            </Nav.Link>

            <Nav.Link as={Link} to="/contact-us" className={location.pathname === "/contact" ? "active" : ""}>
              Contact
            </Nav.Link>

            <Nav.Link as={Link} to="/privacy-policy" className={location.pathname === "/privacy-policy" ? "active" : ""}>
              Privacy Policy
            </Nav.Link>

            <Nav.Link as={Link} to="/terms-and-condition" className={location.pathname === "/terms-and-condition" ? "active" : ""}>
              Terms & Conditions
            </Nav.Link>
            <Nav.Link as={Link} to="/cancellation-policy" className={location.pathname === "/cancellation-policy" ? "active" : ""}>
             Cancellation Policy
            </Nav.Link>
          </div>

          <div className="social_media_icon ">
            {/* <Nav.Link as={Link} to="/terms-and-condition" target="_blank" className="social_icon">
              <FontAwesomeIcon icon={faXTwitter} />
            </Nav.Link> */}

            {/* <Nav.Link as={Link} to="/terms-and-condition" target="_blank" className="social_icon">
              <FontAwesomeIcon icon={faPaperPlane} />
            </Nav.Link> */}

            {/* <Nav.Link as={Link} to="/terms-and-condition" target="_blank" className="social_icon">
              <FontAwesomeIcon icon={faFacebookF} />
            </Nav.Link> */}

            <Nav.Link as={Link} to="https://www.instagram.com/renteasyapp.in?igsh=aDkwYjZnc2x3NWhi" target="_blank" className="social_icon">
              <FontAwesomeIcon icon={faInstagram} />
            </Nav.Link>
          </div>

          <div className="dounload_app">
            <h5>Download Our App</h5>
            <Link to={"https://play.google.com/"} target="_blank">
              <div className="google_play_img_holder">
                <img
                  className="logo_img"
                  src={process.env.PUBLIC_URL + "/assets/images/icons/g-play.png"}
                  alt="google play app"
                />
              </div>
            </Link>
          </div>


          <div className="footer_copyright_holder">
            <p>
              Copyright ©2025 All Rights Reserved. Developed by{" "}
              <Link to="https://www.profcymaglobal.com/" target="_blank">
                <span>Profcyma</span>
              </Link>.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
